"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isColorDark = void 0;

var isColorDark = function isColorDark(hexColor) {
  if (!hexColor || typeof hexColor !== 'string') return false;
  var hex = hexColor.replace('#', '');

  if (hex.length === 3) {
    hex = hex.split('').map(function (c) {
      return c + c;
    }).join('');
  }

  if (hex.length !== 6) return false;
  var r = parseInt(hex.slice(0, 2), 16);
  var g = parseInt(hex.slice(2, 4), 16);
  var b = parseInt(hex.slice(4, 6), 16);
  var luminance = 0.299 * r + 0.587 * g + 0.114 * b;
  return luminance < 140;
};

exports.isColorDark = isColorDark;